import AttachFileIcon from '@mui/icons-material/AttachFile';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import PlaylistAddCheckIcon from '@mui/icons-material/PlaylistAddCheck';
import PlaylistRemoveIcon from '@mui/icons-material/PlaylistRemove';
import { IconButton, useTheme } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import { CustomCellRendererProps } from 'ag-grid-react';
import { useMemo } from 'react';
import { Link } from 'react-router';
import { ROUTES } from '../../../../../constants/RouteNameMapping';
import { IKPIRequestDataModel, KPIRequestStatus } from '../../../../../data-models/kpi-requests.data-model';
import { colors } from '../../../../../theme/colors';
import { MoreRequestOptionsButton } from './DeleteRequest';
import { ActionIndicatorSlot, RequestActionsRow } from './RequestActionsRow';

export default function ActionsCellRenderer(params: ICellRendererParams) {
  const { colors } = useTheme();
  const requestIdResponseRoute = useMemo(() => {
    return ROUTES.KPI_REQUEST_REVIEW.replace(':requestId', `${params?.data?.id}`);
  }, [params?.data?.id]);

  const status = params?.data?.status;
  let Icon = ManageSearchIcon;
  if (status === KPIRequestStatus.Accepted) {
    Icon = PlaylistAddCheckIcon;
  }
  if (status === KPIRequestStatus.Rejected) {
    Icon = PlaylistRemoveIcon;
  }

  if (params?.node?.group) {
    return null;
  }

  return (
    <RequestActionsRow>
      <IconButton
        target='_blank'
        component={Link}
        to={`/${requestIdResponseRoute}`}
        color='secondary'
        size='medium'
      >
        <Icon sx={{ color: colors.primary[60] }} />
      </IconButton>
      <FileAttachedRenderer {...params} />
      <MoreRequestOptionsButton request={params.data} />
    </RequestActionsRow>
  );
}

function FileAttachedRenderer(params: CustomCellRendererProps<IKPIRequestDataModel>) {
  const fileData = params.data?.kpiRequestResponse?.sectionData?.find(
    (s) =>
      (s.value as { fileId: string })?.fileId ||
      (Array.isArray(s.value) && s.value.some((v) => (v as { fileId: string })?.fileId))
  );

  return (
    <ActionIndicatorSlot title={fileData ? 'Contains attached file(s)' : undefined}>
      {fileData && <AttachFileIcon htmlColor={colors.neutral[50]} fontSize='small' />}
    </ActionIndicatorSlot>
  );
}
